import { epodApprovalStatus } from 'pando-constants';

class Order {
  static getObjectValue(array, key, Id) {
    return array.find(item => item[key] === Id);
  }

  static grnEditabilityCheckBasedOnApprovalStatus(order, canEditGrn) {
    let result = canEditGrn;
    const approvalStatus = order.epod_approval_status;
    if (approvalStatus !== epodApprovalStatus.PENDING) {
      result = order.epod_editability_based_on_approval_flow;
    }
    return result;
  }
}

export default Order;
